<div class="po-details">
    <div class="modal-header">
        <div class="row w-100">
            <div class="col-md-11">
                <h4 class="modal-title">Details</h4>
            </div>
            <div class="col-md-1">
                <app-print-common [rowData]="rowData" [columns]="columns"></app-print-common>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div class="card p-3 mb-3">
            <div class="row py-1" *ngFor="let colPair of getColumnPairs(columns)">
                <div class="col-md-6">
                    <label class="form-label" style="font-weight: 700;">{{ colPair[0]?.header }} <span>:&nbsp;</span></label>
                    <span class="form-label" style="word-break: break-all;">
                        {{ rowData[colPair[0]?.key] }}
                    </span>
                </div>


                <div class="col-md-6" *ngIf="colPair[1]">
                    <label class="form-label" style="font-weight: 700;">{{ colPair[1]?.header }} <span>:&nbsp;</span></label>
                    <span class="form-label" style="word-break: break-all;">
                        {{ rowData[colPair[1]?.key] }}
                    </span>

                </div>
            </div>
        </div>
    </div>
</div>